export enum StudentActiveTab {
  'OVERVIEW' = 'Overview',
  'MYCC' = 'MyCC',
  'CYMRUQUEST' = 'CQ',
  'EIRQUEST' = 'EQ',
  'TURQUEST' = 'TQ',
  'MYA' = 'MyA',
  'MYAC' = 'MyAC',
  'MY1C' = 'My1C',
  'MYUC' = 'MyUC',
}

export enum StudentTimelineType {
  'STUDENT' = 'Student',
  'PROGRAMME' = 'Programme',
}
